interface Column {
  key: string;
  label: string;
  className?: string; 
  headerClassName?: string;
}

interface ConfigsCrudTables {
  data: any[];
  columns: Column[];
  fetchUrl: string;
  label: string;
}

const tableConfigs: Record<string, ConfigsCrudTables> = {
  funcionario: {
    label: "Funcionarios/as",
    data: [],
    columns: [
      { key: "id", label: "ID", headerClassName: "headerIdCell"},
      { key: "funcionario", label: "Funcionario"},
      { key: "organica.nombre", label: "Orgánica", headerClassName: "d-none d-md-table-cell", className: "d-none d-md-table-cell"},
      { key: "establecimiento.nombre", label: "Establecimiento", headerClassName: "d-none d-lg-table-cell", className: "d-none d-lg-table-cell"},
    ],
    fetchUrl: `${process.env.REACT_APP_API_URL}/api/admin/allFuncionariosDatatable`,
  },
  organica: {
    label: "Orgánicas",
    data: [],
    columns: [
      { key: "id", label: "ID", headerClassName: "headerIdCell"},
      { key: "nombre", label: "Nombre" },
      { key: "parent.nombre", label: "Pertenece a", headerClassName: "d-none d-md-table-cell", className: "d-none d-md-table-cell"},
    ],
    fetchUrl: `${process.env.REACT_APP_API_URL}/api/admin/allOrganicasDatatable`,
  },
  establecimiento: {
    label: "Establecimientos",
    data: [],
    columns: [
      { key: "id", label: "ID", headerClassName: "headerIdCell"},
      { key: "nombre", label: "Nombre" },
      { key: "provincia_nombre", label: "Provincia", headerClassName: "d-none d-md-table-cell", className: "d-none d-md-table-cell"},
    ],
    fetchUrl: `${process.env.REACT_APP_API_URL}/api/admin/allEstablecimientosDatatable`,
  },
  reparticionGde: {
    label: "Reparticiones GDE",
    data: [],
    columns: [
      { key: "id", label: "ID", headerClassName: "headerIdCell"},
      { key: "nombre", label: "Nombre" },
    ],
    fetchUrl: `${process.env.REACT_APP_API_URL}/api/admin/allReparticionesGdeDatatable`,
  },
  sectorGde: {
    label: "Sectores GDE",
    data: [],
    columns: [
      { key: "id", label: "ID", headerClassName: "headerIdCell"},
      { key: "nombre", label: "Nombre" },
      { key: "reparticion.nombre", label: "Pertenece a", headerClassName: "d-none d-md-table-cell", className: "d-none d-md-table-cell"},
    ],
    fetchUrl: `${process.env.REACT_APP_API_URL}/api/admin/allSectoresGdeDatatable`,
  },
  inactivo: {
    label: "Inactivos",
    data: [],
    columns: [
      { key: "id", label: "ID", headerClassName: "headerIdCell" },
      { key: "fechaDeBaja", label: "Fecha", headerClassName: "headerFechaCell"},
      { key: "funcionario.funcionario", label: "Funcionario"},
      { key: "usuarioDeBajaPor.email", label: "Inactivo por", headerClassName: "d-none d-sm-table-cell", className: "d-none d-sm-table-cell"},
      { key: "estadoCorreo", label: "Estado correo", headerClassName: "d-none d-xl-table-cell", className: "d-none d-xl-table-cell"},
      { key: "usuarioAutorEstadoCorreo.email", label: "Baja de correo", headerClassName: "d-none d-xl-table-cell", className: "d-none d-xl-table-cell"},
      { key: "estadoGde", label: "Estado GDE", headerClassName: "d-none d-xl-table-cell", className: "d-none d-xl-table-cell"},
      { key: "usuarioAutorEstadoGde.email", label: "Baja de GDE", headerClassName: "d-none d-xl-table-cell", className: "d-none d-xl-table-cell"},
    ],
    fetchUrl: `${process.env.REACT_APP_API_URL}/api/admin/allInactivosDatatable`
  },
  default: {
    label: 'Default',
    data: [],
    columns: [],
    fetchUrl: "",
  },
};

export default tableConfigs;
